<template>
  <div class="userBox">
    <div class="userTab">
      <div class="userTabItem">个人信息</div>
    </div>
    <div class="userContent">
      <div class="userContent1">
        <div class="imgBox">
          <div class="imgBoxText">照片:</div>
          <img class="imgBoxImg" style="width: 126px;height: 156px;" @click="upFile" :src="headImg" alt="">
          <p style="color: #d9d9d9;line-height: 30px;padding-left: 30px;position: relative;top: 126px;">建议尺寸：126px*156px</p>
          <el-upload
            style="display: none;"
            accept="image/*"
            action="" drag
            :auto-upload="false"
            :show-file-list="false"
            :on-change='changeUpload'>
            <i class="btnbtn" ref="upload"></i>
          </el-upload>
        </div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="求职状态:" prop="huntingStatus">
            <el-select v-model="ruleForm.huntingStatus" placeholder="请选择求职状态">
              <el-option label="离职" value="1"></el-option>
              <el-option label="在职" value="2"></el-option>
              <el-option label="实习" value="3"></el-option>
<!--              <el-option label="兼职" value="4"></el-option>-->
            </el-select>
<!--            <el-tooltip effect="dark" content="目前求职状态" placement="right">-->
<!--              <img src="../../assets/img/i.jpg" class="icon" alt="">-->
<!--            </el-tooltip>-->
          </el-form-item>
          <el-form-item label="姓名:" prop="realName">
            <el-input v-model="ruleForm.realName" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="性别:" prop="sex">
            <el-radio-group v-model="ruleForm.sex">
              <el-radio label="1">男</el-radio>
              <el-radio label="2">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="所在区域:" required>
            <el-col :span="7" style="margin-right: 10px;">
              <el-form-item prop="addressId0">
                <el-select v-model="ruleForm.addressId0" @change="selectChange1" placeholder="请选择省">
                  <el-option
                    v-for="(item, index) in addressId0Arr"
                    :key="index"
                    :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="7" style="margin-right: 10px;">
              <el-form-item prop="addressId1">
                <el-select v-model="ruleForm.addressId1" @change="selectChange2" placeholder="请选择市">
                  <el-option
                    v-for="(item, index) in addressId1Arr"
                    :key="index"
                    :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item prop="addressId2">
                <el-select v-model="ruleForm.addressId2" placeholder="请选择区县">
                  <el-option
                    v-for="(item, index) in addressId2Arr"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-form-item>

          <el-form-item label="工作经验:" prop="workingLife">
            <el-select v-model="ruleForm.workingLife" @change="workingLifeChiose" placeholder="请选择工作经验" style="width: 100%;">
              <el-option
                v-for="(item, index) in workingLifeArr"
                :key="index"
                :label="item.name"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>


          <el-form-item label="手机号码:" prop="phone">
            <el-input v-model.number="ruleForm.phone" placeholder="请输入手机号"></el-input>
          </el-form-item>

          <el-form-item label="验证码:" prop="phoneCode">
            <el-input v-model.number="ruleForm.phoneCode" placeholder="请输入验证码" >
              <div slot="suffix" class="text" @click="sendCode2">{{codeText}} <span
                v-if="typeof codeText === 'number'">秒</span></div>
            </el-input>
          </el-form-item>


          <el-form-item label="出生日期:" prop="birthday">
            <el-date-picker type="date" placeholder="选择日期" v-model="ruleForm.birthday"
                            style="width: 100%;"></el-date-picker>
          </el-form-item>
          <el-form-item label="邮箱:" prop="email">
            <el-input v-model="ruleForm.email" placeholder="请输入邮箱"></el-input>
          </el-form-item>

          <div class="flex align-center justify-center">
            <el-checkbox v-model="checked" style="margin-right: 0;">请查阅并同意</el-checkbox><a style="display: block;line-height: 31px;text-align: center;color: #00a2ea;" href="/agreement" target="_blank">《用户服务协议》</a>
          </div>

          <el-form-item>
            <el-button type="primary" @click="submitForm" class="btn">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <el-dialog title="图片剪裁" :visible.sync="dialogVisible" append-to-body>
      <div class="cropper-content">
        <div class="cropper" style="text-align:center">
          <vueCropper
            ref="cropper"
            :img="option.img"
            :outputSize="option.size"
            :outputType="option.outputType"
            :info="true"
            :full="option.full"
            :canMove="option.canMove"
            :canMoveBox="option.canMoveBox"
            :original="option.original"
            :autoCrop="option.autoCrop"
            :fixed="option.fixed"
            :fixedNumber="option.fixedNumber"
            :centerBox="option.centerBox"
            :infoTrue="option.infoTrue"
            :fixedBox="option.fixedBox"
            @realTime="realTime"
          ></vueCropper>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="finish" :loading="loading">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import config from '../../config/index'

  export default {
    data() {
      return {
        config: config, // 配置
        headImg: config.defaultHeadImg, // 默认头像
        codeText: '发送验证码', // 验证码文字
        id: null, // 计时器id
        timeId: null, // 一次性计时器id
        ruleForm: {
          headimg: null, // 头像
          dataimg: '', // 不带域名的头像
          huntingStatus: '', // 求职状态
          realName: '', // 名字
          sex: '', // 性别
          addressId: '', // 省ID|市ID|区ID
          addressId0: '',  //  省ID
          addressId1: '', // 城市ID
          addressId2: '', // 区ID
          phone: '', // 手机号
          phoneCode:'',
          birthday: '', // 出生日期
          email: '', // 邮箱
          workingLife:'', //  工作经验id
          workingLifeCn:'', //  工作经验
        },
        checked:false,
        rules: {
          huntingStatus: [
            {required: true, message: '请选择求职状态', trigger: 'change'}
          ],
          realName: [
            {required: true, message: '请输入姓名', trigger: 'blur'}
          ],
          sex: [
            {required: true, message: '请选择性别', trigger: 'change'}
          ],
          workingLife: [
            {required: true, message: '请选择工作经验', trigger: 'change'}
          ],
          addressId0: [
            {required: true, message: '请选择城省', trigger: 'change'}
          ],
          addressId1: [
            {required: true, message: '请选择城市', trigger: 'change'}
          ],
          addressId2: [
            {required: true, message: '请选择区|县', trigger: 'change'}
          ],
          phoneCode: [
            {required: true, message: '请输入验证码', trigger: 'blur'}
          ],
          phone: [
            {required: true, message: '请输入手机号', trigger: 'blur'},
            {type: 'number', message: '请输入正确的数字手机号', trigger: 'blur'},
            {type: 'number', min: 10000000000, max: 19999999999, message: '请输入正确的手机号', trigger: 'blur'}
          ],
          birthday: [
            {type: 'date', required: true, message: '请选择出生日期', trigger: 'change'}
          ],
          email: [
            {required: true, message: '请输入邮箱地址', trigger: 'blur'},
            {type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur,change'}
          ]
        }, // 验证规则
        addressId0Arr: [], // 省下拉数据
        addressId1Arr: [], // 市下拉数据
        addressId2Arr: [], // 区|县下拉数据
        workingLifeArr:[],  //  工作经验数据
        dialogVisible: false,
        // 裁剪组件的基础配置option
        option: {
          img: '', // 裁剪图片的地址
          info: true, // 裁剪框的大小信息
          outputSize: 0.8, // 裁剪生成图片的质量
          outputType: 'jpeg', // 裁剪生成图片的格式
          canScale: false, // 图片是否允许滚轮缩放
          autoCrop: true, // 是否默认生成截图框
          // autoCropWidth: 300, // 默认生成截图框宽度
          // autoCropHeight: 200, // 默认生成截图框高度
          fixedBox: true, // 固定截图框大小 不允许改变
          fixed: true, // 是否开启截图框宽高固定比例
          fixedNumber: [126, 156], // 截图框的宽高比例
          full: true, // 是否输出原图比例的截图
          canMoveBox: false, // 截图框能否拖动
          original: false, // 上传图片按照原始比例渲染
          centerBox: false, // 截图框是否被限制在图片里面
          infoTrue: true // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
        },
        picsList: [],  //页面显示的数组
        // 防止重复提交
        loading: false
      }
    },
    computed: {
      user() {
        return this.$store.state.user
      }
    },
    created() {
      // if(this.$store.state.user.user_name.length !== 11){
      //   this.$confirm('您之前是否已注册用户账号，如果已注册，请关联绑定！', '温馨提示', {
      //     confirmButtonText: '关联绑定',
      //     cancelButtonText: '取消',
      //     center: true,
      //     type: 'warning'
      //   }).then(() => {
      //     this.$router.push('/bindPhone')
      //   })
      // }
      this.init()
    },
    methods: {
      sendCode2() {
        this.$refs.ruleForm.validateField('phone', (valid) => {
          if (!valid) {
            // 发送ajax
            if (this.codeText === '发送验证码' || this.codeText === '重新发送') {
              this.codeText = 60
              this.id = setInterval(() => {
                if (this.codeText === 0) {
                  this.codeText = '重新发送'
                  return
                }
                if (typeof this.codeText === 'number') {
                  this.codeText--
                }
              }, 1000)
              this.$api.apiLogin.sendPhoneCode({
                userName: this.ruleForm.phone,
                type: 1,
                userType: 1
              }).then().catch(e => {
                this.$message.error(e.info)
                this.codeText = '重新发送'
                clearInterval(this.id)
              })
            }
          }
        })
      },
      init() {
        this.$api.apiContent.classification({
          parent_id: 263
        }).then(res=>{

          this.workingLifeArr = res.data
        })
        this.$api.apiContent.getCategoryDistrict({
          userToken: this.$store.state.user.user_token,
          searchName: '',
          parentid: ''
        })
          .then(res => {
            let arr = []
            res.data.map(item => {
              let obj = {
                label: item.categoryname,
                value: item.id
              }
              arr.push(obj)
            })
            this.addressId0Arr = arr
          }).catch()
      },

      changeUpload(file,fileList) {
        console.log(file)
        console.log(fileList)
        const isLt5M = file.size / 1024 / 1024 < 3
        if (!isLt5M) {
          this.$message.error('上传文件大小不能超过 3MB!')
          return false
        }
        this.fileinfo = file
        let  URL = window.URL || window.webkitURL
        // 上传成功后将图片地址赋值给裁剪框显示图片
        this.$nextTick(() => {
          this.option.img = URL.createObjectURL(file.raw)
          console.log(this.option.img)
          this.dialogVisible = true
        })
        console.log(this.option)
      },
      // 点击裁剪，这一步是可以拿到处理后的地址
      finish() {
        this.$refs.cropper.getCropBlob((data) => {
          console.log(data)
          let fd = new window.FormData();
          fd.append('image', data)
          fd.append('userToken', this.$store.state.user.user_token)
          this.$api.apiMember.file2(fd).then(res => {
            console.log(res)
            this.ruleForm.dataimg = res.data
            this.headImg = config.urlStr + '/' + res.data
            this.dialogVisible = false
          }).catch(e => {
            console.log(e)
            this.$message.error(e.info)
          })
        })
      },
      // 上传文件
      upFile() {
        document.querySelector('.btnbtn').click()
      },
      // 上传之前的验证
      beforeUpload(file) {
        var fd = new window.FormData();
        fd.append('image', file)
        fd.append('userToken', this.$store.state.user.user_token)
        this.$api.apiMember.file(fd).then(res => {
          console.log(res)
          this.ruleForm.dataimg = res.data
          this.headImg = config.urlStr + '/' + res.data
        }).catch(e => {
          console.log(e)
          this.$message.error(e.info)
        })
        return false
      },
      realTime (data) {
        this.previews = data
      },
      // 获取市的数据
      selectChange1() {
        this.ruleForm.addressId1 = ''
        this.addressId1Arr = []
        this.ruleForm.addressId2 = ''
        this.addressId2Arr = []
        this.$api.apiContent.getCategoryDistrict({
          userToken: this.$store.state.user.user_token,
          parentid: this.ruleForm.addressId0
        }).then(res => {
          let arr = []
          res.data.map(item => {
            let obj = {
              label: item.categoryname,
              value: item.id
            }
            arr.push(obj)
          })
          this.addressId1Arr = arr
        }).catch(e => {
          console.log(e)
        })
      },
      // 获取区|县的数据
      selectChange2() {
        this.ruleForm.addressId2 = ''
        this.addressId2Arr = []
        this.$api.apiContent.getCategoryDistrict({
          userToken: this.$store.state.user.user_token,
          parentid: this.ruleForm.addressId1
        }).then(res => {
          let arr = []
          res.data.map(item => {
            let obj = {
              label: item.categoryname,
              value: item.id
            }
            arr.push(obj)
          })
          this.addressId2Arr = arr
        }).catch(e => {
          console.log(e)
        })
      },
      //  选择工作经验
      workingLifeChiose(){

      },
      submitForm() {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            if(!this.checked) return this.$message.error('请查看并同意《用户服务协议》')
            // 获取 市 name
            let item0 = this.addressId0Arr.filter(item => {
              return item.value === this.ruleForm.addressId0
            })
            // 获取 市 name
            let item1 = this.addressId1Arr.filter(item => {
              return item.value === this.ruleForm.addressId1
            })
            // 获取 区 name
            let item2 = this.addressId2Arr.filter(item => {
              return item.value === this.ruleForm.addressId2
            })
            // 获取 工作经验 name
            let item4 = this.workingLifeArr.filter(item => {
              return item.id === this.ruleForm.workingLife
            })
            this.$message({
              message: '提交中',
            })
            this.$api.apiMember.addCandidateInfoo({
              userToken: this.$store.state.user.user_token,
              headimg: this.ruleForm.headimg === config.defaultHeadImg ? null : this.ruleForm.dataimg, // 头像
              huntingStatus: this.ruleForm.huntingStatus, // 求职状态
              realName: this.ruleForm.realName, // 名字
              sex: this.ruleForm.sex, // 性别
              addressId: this.ruleForm.addressId0 + '|' + this.ruleForm.addressId1 + '|' + this.ruleForm.addressId2, // 省ID|市ID|区ID
              addressName: item0[0].label + '|' + item1[0].label + '|' + item2[0].label, // 省|市|区
              phone: this.ruleForm.phone, // 手机号
              phoneCode: this.ruleForm.phoneCode, // 手机号验证码
              birthday: new Date(this.ruleForm.birthday).getTime() / 1000, // 出生日期
              email: this.ruleForm.email, // 邮箱
              workingLife:this.ruleForm.workingLife,
              workingLifeCn:item4[0].name
            }).then(res => {
              console.log(res)
              // 获取新的用户数据
              this.$api.apiMember.ShowCandidateInfo({
                userToken: this.$store.state.user.user_token,
                isExecute : this.$store.state.user.is_execute
              }).then(res => {
                this.$message({
                  message: '提交成功',
                  type: 'success'
                })
                this.$store.state.user = res.data
                setTimeout(()=>{
                  this.$router.push({
                    path: '/home/index'
                  })
                },1500)

              }).catch(e => {
                console.log(e)
              })
            }).catch(e => {
              console.log(e)
              this.$message.error(e.info)
            })
          }
        })
      }
    },
    components: {}
  }
</script>

<style scoped lang="scss">
  .userBox {
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: rgba(244, 246, 249, 1);

    .userTab {
      width: 1200px;
      height: 48px;
      margin: 21px auto 0 auto;
      border-bottom: 4px #00a2ea solid;
      background: #ffffff;
      display: flex;
      justify-content: flex-start;
      align-items: flex-end;
      padding-left: 57px;

      .userTabItem {
        width: 133px;
        height: 34px;
        text-align: center;
        line-height: 34px;
        cursor: pointer;
      }
    }

    .userContent {
      width: 1200px;
      margin: 0 auto 39px auto;
      /*height: 798px;*/
      background: #ffffff;
      overflow: hidden;

      .userContent1 {
        width: 500px;
        margin: 67px auto 50px auto;

        .imgBox {
          display: flex;

          .imgBoxText {
            margin: 16px 29px 0 35px;
          }

          .imgBoxImg {
            margin-bottom: 34px;
            cursor: pointer;
          }
        }

        .icon {
          margin-left: 12px;
          cursor: pointer;
        }

        .btn {
          padding: 14px 57px;
          margin: 15px 70px;
        }
      }
    }
  }
  .cropper-content {
    .cropper {
      width: auto;
      height: 300px;
    }
  }
  .text {
    min-width: 80px;
    text-align: center;
    cursor: pointer;
    color: #00a2ea;
  }
</style>
